$(document).ready(function () {
	$('body').addClass('loaded');

	if ($('.add-to-cart-bar .bulk-order-chart').length) {
		$('body').addClass('bulk-order-chart-visible');
	}
});

const getMobileOS = () => {
	const ua = navigator.userAgent;
	if (/android/i.test(ua)) {
		return 'Android';
	} else if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
		return 'iOS';
	}
	return 'Other';
};

document.addEventListener('DOMContentLoaded', function () {
	const os = getMobileOS();
	var body = document.body;
	body.classList.add(os);

	//main nav
	// Tablet in desktop view //
	if (document.body.classList.contains('Android') || document.body.classList.contains('iOS')) {
		// Get all elements with the same class
		const elements = document.querySelectorAll('.item-1.has-mega-menu > a');

		elements.forEach((element) => {
			element.addEventListener('click', (e) => {
				e.preventDefault();
				if (element.parentElement.classList.contains('active')) {
					element.parentElement.classList.remove('active');
					element.parentElement.querySelector('.mega-menu-wrapper').classList.remove('active');
					document.querySelector('.mega-nav-overlay').classList.remove('active');
				} else {
					const activeMegaMenuItem = document.querySelector('.item-1.has-mega-menu.active');
					const activeOverlay = document.querySelector('.mega-nav-overlay.active');
					if (activeMegaMenuItem !== null) {
						activeMegaMenuItem.classList.remove('active');

						if (activeOverlay !== null) activeOverlay.classList.remove('active');
					}
					element.parentElement.classList.add('active');
					element.parentElement.querySelector('.mega-menu-wrapper').classList.add('active');
					document.querySelector('.mega-nav-overlay').classList.add('active');
				}
			});
		});
		document.addEventListener('click', function (event) {
			const openNav = document.querySelector('.main-nav');

			if (openNav !== null) {
				const outsideClick = !openNav.contains(event.target);
				const activeItem = document.querySelector('.item-1.has-mega-menu.active');
				const activeOverlay = document.querySelector('.mega-nav-overlay.active');
				const megaMenuWrapper = document.querySelector('.mega-menu-wrapper');

				if (outsideClick) {
					if (activeItem !== null) activeItem.classList.remove('active');

					if (activeOverlay !== null) activeOverlay.classList.remove('active');

					if (megaMenuWrapper !== null) megaMenuWrapper.classList.remove('active');
				}
			}
		});
	} else {
		// Desktop main nav //

		// Get all elements with the same class
		const elements = document.querySelectorAll('.item-1.has-mega-menu');

		// Flag variable to track hover state and timing for each element
		const hoverStates = {};
		let hoveredItem;

		// Function to handle hover events
		function handleHover(element) {
			if (!hoverStates[element]) {
				// Mouse entered the element
				hoverStates[element] = true;
				if (element != hoveredItem) {
					hoveredItem = element;
					document.querySelector('.mega-nav-overlay').classList.add('active');
					element.classList.add('active');
					element.querySelector('.mega-menu-wrapper').classList.add('active');
				}
			} else {
				// Mouse quickly moved away and then returned
			}
		}

		// Add event listeners for each element
		elements.forEach((element) => {
			element.addEventListener('mouseenter', () => {
				clearTimeout(hoverStates[element]); // Clear any existing timeout
				hoveredItem = null;
				handleHover(element);
			});

			element.addEventListener('mouseleave', () => {
				clearTimeout(hoverStates[element]); // Clear any existing timeout
				hoveredItem = null;

				if (!$('*:hover').hasClass('indicator')) {
					hoverStates[element] = false; // Reset hover state
					element.classList.remove('active');

					const activeMega = document.querySelector('.mega-menu-wrapper.active');
					const activeMegaOverlay = document.querySelector('.mega-nav-overlay.active');

					if (activeMega !== null) activeMega.classList.remove('active');

					if (activeMegaOverlay !== null) activeMegaOverlay.classList.remove('active');
				}
			});
		});
	}

	const checkTabs = () => {
		if (window.innerWidth > 991) {
			if (document.querySelector('.feature-tabs .js-tab-pane')) {
				if (!document.querySelector('.feature-tabs .js-tab-pane.active')) {
					document.querySelector('.feature-tabs .js-tab-pane').classList.add('active');
				}
			}
		}
	};

	setTimeout(function () {
		window.dispatchEvent(new Event('resize'));
	}, 1000);

	let userAgentString = navigator.userAgent;
	// Detect Chrome
	let chromeAgent = userAgentString.indexOf('Chrome') > -1;

	// Detect Safari
	let safariAgent = userAgentString.indexOf('Safari') > -1;
	// Discard Safari since it also matches Chrome
	if (chromeAgent && safariAgent) safariAgent = false;

	if (safariAgent) {
		body.classList.add('safari');
	}

	window.addEventListener('resize', checkTabs);

	document.querySelectorAll('.js-accordion-btn').forEach((item) => {
		item.addEventListener('click', (event) => {
			if (event.target.parentElement.classList.contains('active')) {
				event.target.parentElement.classList.remove('active');
			} else {
				if (document.querySelector('.js-tab-pane.active')) {
					document.querySelector('.js-tab-pane.active').classList.remove('active');
				}
				event.target.parentElement.classList.add('active');
				event.target.scrollIntoView();
			}
		});
	});

	if (document.querySelectorAll('.js-description-button').length > 0) {
		document.querySelector('.js-description-button').addEventListener('click', function (event) {
			if (window.innerWidth < 992) {
				document.querySelector('#description-pane').scrollIntoView();

				// if it isn't open
				if (!document.querySelector('#description-pane').classList.contains('active')) {
					document.querySelector('#description-pane').firstElementChild.click();
				}
			} else {
				document.getElementById('description-tab').click();
				document.querySelector('#featureTabs').scrollIntoView();
			}

			event.preventDefault();
		});
	}

	// reviews accordion
	// Get the parent element that will contain the dynamic elements
	var reviewsWrapper = document.querySelector('.feature-tabs');

	if (reviewsWrapper) {
		// Add a click event listener to the parent element
		reviewsWrapper.addEventListener('click', function (event) {
			// Check if the clicked element has a specific class or tag name
			if (
				event.target.classList.contains('js-accordion-btn-reviews') ||
				event.target.parentNode.classList.contains('js-accordion-btn-reviews')
			) {
				if (window.innerWidth < 992) {
					// if it isn't open
					if (!document.querySelector('#vueReviews').classList.contains('active')) {
						if (reviewsWrapper.querySelector('.js-tab-pane.active')) {
							reviewsWrapper.querySelector('.js-tab-pane.active').classList.remove('active');
						}
						document.querySelector('.js-accordion-btn-reviews').scrollIntoView();
						document.querySelector('#vueReviews').classList.add('active');
					} else {
						document.querySelector('#vueReviews').classList.remove('active');
					}
				}
				event.preventDefault();
			}
		});
	}

	// Get the parent element that will contain the dynamic elements
	var headerWrapper = document.querySelector('.product-header-wrapper');

	if (headerWrapper) {
		// Add a click event listener to the parent element
		headerWrapper.addEventListener('click', function (event) {
			// Check if the clicked element has a specific class or tag name
			if (
				event.target.classList.contains('js-reviews-button') ||
				event.target.parentNode.classList.contains('js-reviews-button')
			) {
				if (window.innerWidth < 992) {
					document.querySelector('#vueReviews').scrollIntoView();

					// if it isn't open
					if (!document.querySelector('#vueReviews').classList.contains('active')) {
						document.querySelector('#vueReviews').classList.add('active');
					}
				} else {
					document.querySelector('#reviews-tab').scrollIntoView();
					document.querySelector('#reviews-tab').click();
				}
				event.preventDefault();
			}
		});
	}

	/* SLIDE UP */
	let slideUp = (target, duration = 500) => {
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.boxSizing = 'border-box';
		target.style.height = target.offsetHeight + 'px';
		target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		window.setTimeout(() => {
			target.style.display = 'none';
			target.style.removeProperty('height');
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
			//alert("!");
		}, duration);
	};
	let slideDown = (target, duration = 500) => {
		target.style.removeProperty('display');
		let display = window.getComputedStyle(target).display;
		if (display === 'none') display = 'block';
		target.style.display = display;
		let height = target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		target.offsetHeight;
		target.style.boxSizing = 'border-box';
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.height = height + 'px';
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		window.setTimeout(() => {
			target.style.removeProperty('height');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	};
	/* TOOGLE */
	var slideToggle = (target, duration = 500) => {
		if (window.getComputedStyle(target).display === 'none') {
			return slideDown(target, duration);
		} else {
			return slideUp(target, duration);
		}
	};

	document.addEventListener('click', function (e) {
		const target = e.target.closest('.js-trigger-details'); // Or any other selector.
		if (target) {
			const targetId = target.href;
			const slug = targetId.split('#').pop();
			target.setAttribute('aria-expanded', target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
			if (document.getElementById(slug).classList.contains('active-slide')) {
				document.getElementById(slug).classList.remove('active-slide');
				document.getElementById(slug).style.height = '0';
			} else {
				setTimeout(function () {
					document.getElementById(slug).classList.add('active-slide');
					const newHeight = document.getElementById(slug).dataset.height;
					document.getElementById(slug).style.height = newHeight + 'px';
				}, 10);
			}
			e.preventDefault();
		}
	});

	//show hide more on homepage
	if (document.querySelectorAll('.js-hide-content p').length > 1) {
		// element that will be wrapped
		const hideContent = document.querySelector('.js-hide-content');
		hideContent.querySelector('p').classList.add('hide-content-first');
		const elems = document.querySelectorAll('.hide-content-first ~ p');

		let newElem = document.createElement('div');
		newElem.classList.add('hide-content-wrapper');
		Array.prototype.forEach.call(elems, function (c) {
			newElem.appendChild(c);
		});

		document.querySelector('.js-hide-content').appendChild(newElem);
		let dropArrow = document.createElement('p');
		dropArrow.classList.add('content-read-more');
		dropArrow.innerHTML = '<span class="more">Read more</span><span class="less">Read less</span>';
		document.querySelector('.js-hide-content').appendChild(dropArrow);
		hideContent.classList.remove('js-hide-content');

		dropArrow.addEventListener('click', function (e) {
			newElem.classList.add('hide-content-wrapper--show');
			slideToggle(document.querySelector('.hide-content-wrapper--show'), 1000);
			if (dropArrow.classList.contains('active')) {
				dropArrow.classList.remove('active');
			} else {
				dropArrow.classList.add('active');
			}
		});
	}
});

// FAQs
document.addEventListener('click', function (e) {
	const target = e.target.closest('.js-accordion-button'); // Or any other selector.

	if (target) {
		const growDiv = target.nextElementSibling;
		const wrapper = growDiv.querySelector('.js-accordion-content__inner');

		if (target.parentElement.classList.contains('active-accordion')) {
			target.parentElement.classList.remove('active-accordion');
			growDiv.style.height = 0;
		} else {
			if (document.querySelector('.accordion-item.active-accordion')) {
				document.querySelector('.accordion-item.active-accordion .accordion-content').style.height = 0;
				document.querySelector('.accordion-item.active-accordion').classList.remove('active-accordion');
			}
			target.parentElement.classList.add('active-accordion');
			growDiv.style.height = wrapper.clientHeight + 'px';
		}
	}
});

$(function () {
	function checkCookieBar() {
		if ($('#onetrust-banner-sdk').is(':visible')) {
			$('body').addClass('cookie-visible');
		} else {
			$('body').removeClass('cookie-visible');
		}
	}

	setTimeout(function () {
		if (document.getElementById('onetrust-accept-btn-handler')) {
			document.getElementById('onetrust-accept-btn-handler').addEventListener('click', function () {
				setTimeout(function () {
					checkCookieBar();
				}, 500);
			});
			document.getElementById('onetrust-close-btn-container').addEventListener('click', function () {
				setTimeout(function () {
					checkCookieBar();
				}, 500);
			});
		}
	}, 1500);

	setTimeout(function () {
		checkCookieBar();
	}, 1000);
	setTimeout(function () {
		checkCookieBar();
	}, 2000);

	// Scroll to top
	var scrolltopShow = $(window).height() / 2,
		scrollBtn = $('.scrolltop');
	function scrollTop() {
		if ($(window).scrollTop() >= scrolltopShow) {
			checkCookieBar();
			scrollBtn.addClass('show');
		} else {
			checkCookieBar();
			scrollBtn.removeClass('show');
		}
	}
	scrollBtn.click(function (e) {
		e.preventDefault();
		$('html, body').animate(
			{
				scrollTop: $('html').offset().top,
			},
			1000
		);
	});

	// On scroll functions
	window.onscroll = function () {
		scrollTop();
	};

	/// Hero slider
	var sliderOptions = {
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		appendDots: '.js-dots-wrapper',
		responsive: [
			{
				breakpoint: 992,
				settings: {
					adaptiveHeight: false,
				},
			},
			{
				breakpoint: 480,
				settings: {
					adaptiveHeight: true,
				},
			},
		],
	};
	if ($('.slider-wrapper').length > 0) {
		$('.slider-wrapper').slick(sliderOptions);
	}

	if ($('.testimonial-slider').length > 0) {
		$('.testimonial-slider').slick(sliderOptions);
	}

	/// Product slider
	var productSliderOption = {
		autoplay: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		variableWidth: false,
		adaptiveHeight: true,
		dots: false,
		infinite: false,
		focusOnSelect: false,
		arrows: true,
		nextArrow:
			'<button class="btn btn-lg btn-square btn-rounded btn-secondary slick-next"><i class="material-icons">keyboard_arrow_right</i></button>',
		prevArrow:
			'<button class="btn btn-lg btn-square btn-rounded btn-secondary slick-prev"><i class="material-icons">keyboard_arrow_left</i></button>',
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					arrow: true,
					variableWidth: true,
					adaptiveHeight: true,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: true,
					arrow: true,
					adaptiveHeight: true,
				},
			},
		],
	};
	if ($('.product-slider-wrapper').length > 0) {
		$('.product-slider-wrapper').slick(productSliderOption);
	}

	var sliderMobileOptions = {
		autoplay: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		variableWidth: true,
		adaptiveHeight: true,
		dots: false,
		infinite: false,
		focusOnSelect: false,
		arrows: false,

		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	if ($('.slider-mobile').length > 0) {
		$('.slider-mobile').slick(sliderMobileOptions);
	}

	var selectorSliderOptions = {
		autoplay: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		variableWidth: true,
		dots: false,
		infinite: false,
		focusOnSelect: false,
		arrows: false,

		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
		],
	};

	var trustBarSlider = {
		autoplay: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		variableWidth: false,
		adaptiveHeight: true,
		dots: false,
		infinite: false,
		focusOnSelect: false,
		arrows: false,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
		],
	};

	if ($(window).width() <= 750) {
		if ($('.selector-slider').length > 0) {
			$('.selector-slider').slick(selectorSliderOptions);
		}
	}

	if ($(window).width() <= 1144) {
		if ($('.trustbar').length > 0) {
			$('.trustbar').slick(trustBarSlider);
		}
	}

	$(window).on('resize', function () {
		if ($(window).width() > 750) {
			if ($('.selector-slider.slick-slider').length > 0) {
				$('.selector-slider.slick-slider').slick('unslick');
			}
		} else {
			if ($('.selector-slider:not(.slick-slider)').length > 0) {
				$('.selector-slider:not(.slick-slider)').slick(selectorSliderOptions);
			}
		}

		if ($(window).width() > 1145) {
			if ($('.trustbar').hasClass('slick-initialized')) {
				$('.trustbar').slick('unslick');
			}
		} else {
			if ($('.trustbar').length > 0) {
				if (!$('.trustbar').hasClass('slick-initialized')) {
					$('.trustbar').slick(trustBarSlider);
				}
			}
		}
	});

	// Sidebar filter checkbox limit
	// and show see more button
	var checkboxToShow = 5;

	if ($('.single-filter').length > 0) {
		$('.single-filter').each(function () {
			var checkboxElement = $(this).children('.checkbox-wrapper').children();
			var totalCheckboxCount = $(this).children('.checkbox-wrapper').children().length;
			if (totalCheckboxCount > 6) {
				checkboxElement.slice(checkboxToShow).hide();
				$(this).children('.checkbox-wrapper').append('<a href="#" class="showmore small">See more</a>');
			}
		});

		$('.single-filter .filter-toggle').on('click', function (e) {
			e.preventDefault();
			$(this).toggleClass('active');
			$(this).siblings('.checkbox-wrapper').slideToggle(300);
		});
	}

	$(document).on('click', '.showmore', function (e) {
		e.preventDefault();
		$(this).hide();
		$(this).closest('.checkbox-wrapper').children('.custom-checkbox').slice(checkboxToShow).slideDown(250);
	});

	let mainSlider,
		thumbnailSlider,
		lightboxThumbnailSlider,
		lightboxMainSlider,
		currentSlideNo,
		globalSlideNumber = 0;

	window.changeSlideImgClick = function changeSlideImgClick(gslide) {
		globalSlideNumber = gslide;

		if (document.querySelectorAll('.slider .js-trigger-lightbox').length > 1) {
			mainSlider.scrollItem(gslide, true);
			if (lightboxMainSlider) {
				lightboxMainSlider.scrollItem(gslide, true);
			}
			if (lightboxMainSlider) {
				lightboxThumbnailSlider.scrollItem(gslide, false);
			}
			thumbnailSlider.scrollItem(gslide, false);

			changeActiveState(gslide);
		}
	};

	function changeActiveState(slideNo) {
		document.querySelectorAll('.glider-slide.active-slide').forEach((item) => {
			item.classList.remove('active-slide');
		});
		document.querySelectorAll('.glider-slide[data-gslide="' + slideNo + '"]').forEach((item) => {
			item.classList.add('active-slide');
		});

		updateArrows(slideNo);
	}

	function updateArrows(newSlide) {
		const totalNumber = document.querySelectorAll('.js-trigger-lightbox.glider-slide').length - 1;
		newSlide = parseInt(newSlide);

		// prev slide
		document.querySelectorAll('.product-glider-prev').forEach((item) => {
			if (newSlide == 0) {
				item.disabled = true;
			} else if (newSlide > 0) {
				item.disabled = false;
			}
		});

		// next slide
		document.querySelectorAll('.product-glider-next').forEach((item) => {
			if (newSlide == totalNumber) {
				item.disabled = true;
			} else {
				item.disabled = false;
			}
		});
	}

	// Checking product thumbnail sliderOptio
	function productThumbSlider() {
		if (document.querySelectorAll('.product-thumb-slider').length > 0) {
			// if only 1 item then remove the arrows
			if (document.querySelectorAll('.product-thumb-slider .slider picture').length <= 1) {
				document.querySelectorAll('.js-glider-arrow').forEach((item) => {
					item.remove();
				});
				document.querySelectorAll('.js-glider-lightbox-arrow').forEach((item) => {
					item.remove();
				});
			} else {
				mainSlider = new Glider(document.querySelector('.slider'), {
					slidesToShow: 1,
					dots: false,
					draggable: false,
					scrollLock: true,
					arrows: false,
				});

				thumbnailSlider = new Glider(document.querySelector('.slider-nav-thumbnails'), {
					slidesToShow: 'auto',
					slidesToScroll: 1,
					dots: false,
					draggable: false,
					scrollLock: false,
					itemWidth: 97,
					exactWidth: 97,
					arrows: false,
				});
				setTimeout(function () {
					// add first active class
					document.querySelector('.slider-nav-thumbnails .glider-slide').classList.add('active-slide');
				}, 400);

				// slider arrows
				document.querySelectorAll('.js-glider-arrow').forEach((item) => {
					item.addEventListener('click', (event) => {
						const totalNumber = document.querySelectorAll('.js-trigger-lightbox.glider-slide').length;

						const parentElement = event.target.parentElement.parentElement;
						const parentSlider = parentElement.querySelector('.glider');
						currentSlideNo = parentSlider.querySelector('.glider-slide.active').getAttribute('data-gslide');
						currentSlideNo = parseInt(currentSlideNo);

						if (event.target.parentElement.dataset.direction == 'next') {
							if (currentSlideNo + 1 < totalNumber) {
								changeSlideImgClick(currentSlideNo + 1);
							}
						} else {
							if (currentSlideNo >= 1) {
								changeSlideImgClick(currentSlideNo - 1);
							}
						}
					});
				});

				// Main slider thunmbnails
				document.querySelectorAll('.slider-nav-thumbnails .glider-slide').forEach((item) => {
					item.addEventListener('click', (event) => {
						changeSlideImgClick(event.target.parentElement.dataset.gslide);
					});
				});
			}
		}
	}

	productThumbSlider();

	if (document.querySelector('.fabrication-slider')) {
		new Glider(document.querySelector('.fabrication-slider'), {
			slidesToShow: 1,
			dots: '.fabrication-slider__dots',
			draggable: true,
			arrows: false,
			scrollLock: true,
		});
	}

	$('.js-trigger-lightbox').on('click', function (e) {
		e.preventDefault();
		$('.light-box-slider').addClass('show');
		$('body').addClass('modal-open');

		if (!document.querySelector('.slider-lightbox').classList.contains('glider')) {
			// run lightbox slider
			lightboxMainSlider = new Glider(document.querySelector('.slider-lightbox'), {
				slidesToShow: 1,
				dots: false,
				draggable: false,
				scrollLock: true,
				arrows: false,
			});

			if (document.querySelector('.slider-nav-thumbnails-lightbox')) {
				lightboxThumbnailSlider = new Glider(document.querySelector('.slider-nav-thumbnails-lightbox'), {
					slidesToShow: 'auto',
					slidesToScroll: 1,
					dots: false,
					draggable: false,
					scrollLock: false,
					itemWidth: 97,
					exactWidth: 97,
					arrows: false,
				});
			}

			// lightbox slider thumbnails
			document.querySelectorAll('.slider-nav-thumbnails-lightbox .glider-slide').forEach((item) => {
				item.addEventListener('click', (event) => {
					changeSlideImgClick(event.target.parentElement.dataset.gslide);
				});
			});
		}

		setTimeout(function () {
			changeSlideImgClick(globalSlideNumber);
		}, 10);

		if (document.querySelectorAll('.slider-lightbox').length > 0) {
			document.querySelector('.slider-lightbox').style.height = window.innerHeight - 100 + 'px';

			window.addEventListener('resize', (e) => {
				document.querySelector('.slider-lightbox').style.height = window.innerHeight - 100 + 'px';
			});
		}
	});
	$('.close-lightbox').on('click', function (e) {
		e.preventDefault();
		$('.light-box-slider').removeClass('show');
		$('body').removeClass('modal-open');
	});

	// Cart details dropdown
	$('.item-feature a').on('click', function (e) {
		e.preventDefault();
		$(this).siblings('ul').toggleClass('active');
	});

	if ($('.success-story').length > 0) {
		var contentHeight = $('.success-story').height();
		$('.success-story')
			.prev('section')
			.css('padding-bottom', contentHeight / 2 + 40 + 'px');

		$('.success-story').css('margin-top', -contentHeight / 2 + 'px');
	}

	if ($('.trigger-filter').length > 0) {
		$('.trigger-filter').on('click', function (e) {
			e.preventDefault();
			$('.filter-block').addClass('active');
			$('body').addClass('modal-open');
		});

		$('.close-filter').on('click', function (e) {
			e.preventDefault();
			$('.filter-block').removeClass('active');
			$('body').removeClass('modal-open');
		});
	}

	$(document.body).on('click', '.js-accept-terms', function (e) {
		$('#terms-condition').prop('checked', true);
		$('.close').click();
	});

	$(document.body).on('click', '.js-cancel-terms', function (e) {
		$('#terms-condition').prop('checked', false);
		$('.close').click();
	});

	var menu = $('.main-nav');

	if (menu.length > 0) {
		var indicator = $('<span class="indicator"></span>');
		menu.append(indicator);
		position_indicator(menu.find('.item-1'));
		menu.find('.item-1').mouseenter(function () {
			position_indicator($(this));

			menu.addClass('hover');
		});
		menu.find('.item-1').mouseleave(function () {
			position_indicator($(this));
			menu.removeClass('hover');
		});
	}
	function position_indicator(ele) {
		var left = ele.offset().left;
		var width = ele.width();
		indicator.stop().animate(
			{
				left: left,
				width: width,
			},
			100
		);
	}

	// Tab duplication id fixing script
	if ($(window).width() < 992) {
		$('.show-tab-on-desktop').appendTo('.show-tab-on-mobile');
	}
	$(window).on('resize', function () {
		if ($(window).width() < 992) {
			$('.show-tab-on-desktop .tab-wrapper').appendTo('.show-tab-on-mobile');
		} else {
			$('.show-tab-on-mobile .tab-wrapper').appendTo('.show-tab-on-desktop');
		}
	});

	/// Toolbar secondary nav
	$('.header-toolbar .dropdown-toggle').on('click', function (e) {
		e.preventDefault();
		$(this).parent().toggleClass('show');
	});

	$(document).on('click', function (event) {
		if (!$(event.target).closest('.header-toolbar .dropdown').length) {
			$('.header-toolbar .dropdown').removeClass('show');
			//$('.info-icon-block .show-info').removeClass('show');
		}
	});

	setTimeout(function () {
		$('.cookie-bar, .article-bar, .global-bar.top').addClass('show');
	}, 3000);

	// Youtube video with image over the top
	$('.embed-responsive.video-embed .play-video').click(function (e) {
		const url = $('.js-iframe-holder').attr('data-src');
		const iframeWidth = $('.js-iframe-holder').attr('data-width');
		const iframeHeight = $('.js-iframe-holder').attr('data-height');

		e.preventDefault();
		$(this).parent().toggleClass('video-active');
		$('.js-iframe-holder').html(
			'<iframe src="' +
				url +
				'" width="' +
				iframeWidth +
				'" height="' +
				iframeHeight +
				'" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>'
		);
	});
});

// Sort by select box width change base
// On option width
(function ($, window) {
	var arrowWidth = 20;

	$.fn.resizeselect = function (settings) {
		return this.each(function () {
			$(this)
				.change(function () {
					var $this = $(this);

					// create test element
					var text = $this.find('option:selected').text();
					var $test = $('<span>')
						.html(text)
						.css({
							'font-size': $this.css('font-size'), // ensures same size text
							visibility: 'hidden', // prevents FOUC
						});

					// add to parent, get width, and get out
					$test.appendTo($this.parent());
					var width = $test.width();
					$test.remove();

					// set select width
					$this.width(width + arrowWidth);

					// run on start
				})
				.change();
		});
	};

	// run by default
	$('select.sort-select').resizeselect();
})(jQuery, window);

//native javscript updates
window.addEventListener('load', function (event) {
	/**
	 * Responsive Tables
	 */
	initResponsiveTables();

	/**
	 * Mmenu Light
	 */

	/**
	 * Toggle Password visibility
	 */
	initTogglePasswordField();

	function hideElementUntilLoaded() {
		var hideUntilLoaded = document.querySelectorAll('.hide-until-loaded');
		hideUntilLoaded.forEach(function (item) {
			item.classList.remove('hide-until-loaded');
		});
	}

	setTimeout(hideElementUntilLoaded, 1000);
});

function initResponsiveTables() {
	const table = document.querySelectorAll('table.table');
	table.forEach(function (el) {
		var wrapper = document.createElement('div');
		wrapper.className = 'table-responsive';

		el.parentNode.insertBefore(wrapper, el);
		wrapper.appendChild(el);
	});
}

function initTogglePasswordField() {
	var togglePasswords = document.querySelectorAll('.toggle-password');

	togglePasswords.forEach(function (togglePassword) {
		togglePassword.onclick = function () {
			var pass = this.nextElementSibling;
			if (pass.className === 'form-control') {
				var attr = pass.getAttribute('type');
				if (attr == 'password') {
					pass.setAttribute('type', 'text');
					this.innerText = 'Hide';
				} else {
					pass.setAttribute('type', 'password');
					this.innerText = 'Show';
				}
			}
		};
	});
}

function scroll(el) {
	el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
}

function accordionToggle(items) {
	if (items === undefined) {
		items = document.getElementsByClassName('ac-toggle');
	}

	if (items === null) return;
	//console.log('items: ', items)
	for (let i = 0; i < items.length; i++) {
		items[i].addEventListener('click', function (event) {
			event.preventDefault();
			resetItems(this);
			this.classList.toggle('active');
			const content = this.nextElementSibling;
			content.classList.toggle('active');
		});
	}
}

/**
 *  Resets the open accordion items
 * @param {any} thisItem
 */
function resetItems(thisItem) {
	const activeItems = document.querySelectorAll('.ac-toggle.active');
	for (let i = 0; i < activeItems.length; i++) {
		if (activeItems[i] !== thisItem) {
			activeItems[i].classList.remove('active');
			const content = activeItems[i].nextElementSibling;
			content.style = null;
			content.classList.remove('active');
		}
	}
}

// Define the global function
window.initializeLazyLoading = function (rootMargin) {
	const options = {
		threshold: 0.1,
		loaded: function (el) {
			el.classList.add('loaded');
		},
	};

	if (rootMargin !== undefined) {
		options.rootMargin = rootMargin;
	}

	window.observerImages = lozad('[data-lazyload]', options);
	window.observerImages.observe();
};

document.addEventListener('DOMContentLoaded', function () {
	accordionToggle();
	window.initializeLazyLoading('10px 0px');
});


if (document.querySelectorAll('.js-read-more').length > 0) {
	const readMoreElement = document.querySelectorAll('.js-read-more');

	readMoreElement.forEach((element) => {
		const readMoreButton = element.querySelector('.js-read-more-button');
		const readMoreContent = element.querySelector('.js-read-more-content');
		const readMoreContentInner = element.querySelector('.js-read-more-content-inner');
		const readMoreContentHeight = readMoreContentInner.clientHeight;

		// if height of readMoreContent is greater than 250px, add class of hidden
		if (readMoreContentHeight > 250) {
			readMoreContentInner.classList.add('read-more-content--hidden');
			readMoreContent.style.height = '200px';
		} else {
			readMoreButton.style.display = 'none';
		}

		readMoreButton.addEventListener('click', (event) => {
			event.preventDefault();

			if (readMoreContentInner.classList.contains('read-more-content--hidden')) {
				readMoreContentInner.classList.remove('read-more-content--hidden');
				readMoreButton.classList.add('read-more-button--hidden');
				readMoreContent.style.height = readMoreContentHeight + 'px';
			} else {
				readMoreContentInner.classList.add('read-more-content--hidden');
				readMoreButton.classList.remove('read-more-button--hidden');
				readMoreContent.style.height = '200px';
			}
		});
	});
}

if (!CSS.supports('aspect-ratio: 16/9')) {
	document.body.classList.add('no-aspect-ratio');
}